import {updateLivescoreUI} from "./livescore-update-data.js";

let updatedData = {};
let lastFlatData = {};

export async function poll(liveDataUrl, interval = 20000) {
    let testDataUrl = 'https://gong2025.ni.bg:4433/webpack/src/components/livescore/data/livescore_update.json';
    
    console.log('AJAX POLL called ===============================');
    let lastData = [];

    setInterval(async () => {
        try {
            //console.log('Last data:', lastData);
            
            const response = await fetch(liveDataUrl);
            //const response = await fetch(testDataUrl);
            const data = await response.json();
            
//            console.log('New data:', data);
//            console.log('New data !== Last data', JSON.stringify(data) !== JSON.stringify(lastData), JSON.stringify(data), JSON.stringify(lastData));
            
            if (JSON.stringify(data) !== JSON.stringify(lastData)) {
                
                updatedData = compareMatches(lastData, data); //different matches
                console.log('Updated data:', updatedData);

                updateLivescoreUI(updatedData);

                lastData = data;

            } else {
                console.log('No change');
            }

        } catch (err) {
            console.error('Polling error:', err);
        }
    }, interval);
}

//Used to extract the changed data
function compareMatches(lastData, newData) {
    
    newData.forEach(newObj => {
        
        const oldObj = lastData[0];        
        //const lastUpdatedData = JSON.parse(JSON.stringify(updatedData));//should be last flat data before trimming
       // const lastUpdatedData = JSON.parse(JSON.stringify(lastFlatData));//last flat data before trimming
        
        if (!oldObj || Object.keys(oldObj).length == 0 || JSON.stringify(oldObj) !== JSON.stringify(newObj)) {
            
            updatedData = {};
            //console.log('lastUpdatedData before calling flat data', lastFlatData);
            newObj?.updateResult?.forEach(item => flattenData(item, lastFlatData));
            newObj?.syncTimes?.forEach(item => flattenData(item, lastFlatData));
            newObj?.halftimes?.forEach(item => flattenData(item, lastFlatData));
            newObj?.odds?.forEach(item => flattenData(item, lastFlatData));
            newObj?.lastVideoThumb?.forEach(item => flattenData(item, lastFlatData));
        }
    });
    
    return updatedData;
}

function flattenData(item, lastFlatData) {
    
    if (!item) return; // skip nulls
    const {match_id, ...rest} = item;
    const id = match_id.toString();
    
    const previous = { ...(lastFlatData[id] || {}) }; // safe clone

    if (!updatedData[id]) {
        updatedData[id] = {};
    }
    if (!lastFlatData[id]) {
        lastFlatData[id] = {};
    }
    
    
    for (const key in rest){        
        const cleanKey = key.trim();  
        lastFlatData[id][key] = rest[key];
        if(rest[key] !== previous[key]){
            updatedData[id][key] = rest[key];
        }
    }
}